/**
 * Returns the hostname of a given URL string
 */
export const getHostName = (
  /** URL to extract hostname from */
  urlStr: string
): string => {
  try {
    const url = new URL(urlStr);
    return url.hostname;
  } catch (e) {
    return '';
  }
};
